module.exports = global["humps"] = require("-!./humps.js");


//////////////////
// WEBPACK FOOTER
// /var/www/24tru/releases/20230713222349/htdocs-rails/node_modules/humps/humps.js-exposed
// module id = 22
// module chunks = 16